'use client';
import React, { useState } from 'react';


const AVG_DELIVERIES_PER_DRIVER_PER_MONTH = 18;
const COMMISSION_PER_DELIVERY = 4.5; // EC$

export default function EarningsEstimator() {
  const [driverCount, setDriverCount] = useState(5);

  const monthlyEarnings = driverCount * AVG_DELIVERIES_PER_DRIVER_PER_MONTH * COMMISSION_PER_DELIVERY;
  const annualEarnings = monthlyEarnings * 12;

  return (
    <section id="earnings" className="py-24 px-6">
      <div className="max-w-screen-xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-[#F59E0B] text-sm font-mono font-medium uppercase tracking-widest mb-3">
            Earnings Calculator
          </p>
          <h2 className="font-display font-bold text-4xl md:text-5xl text-white mb-4">
            What could you earn?
          </h2>
          <p className="text-[#9CA3AF] text-lg max-w-xl mx-auto">
            Drag the slider to estimate your monthly earnings based on how many drivers you refer.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="card p-8">
            {/* Slider */}
            <div className="mb-10">
              <div className="flex justify-between items-center mb-4">
                <label className="font-display font-semibold text-white text-lg">
                  Drivers you refer
                </label>
                <span className="font-mono text-3xl font-bold text-[#F59E0B]">{driverCount}</span>
              </div>
              <input
                type="range"
                min={1}
                max={20}
                value={driverCount}
                onChange={(e) => setDriverCount(parseInt(e?.target?.value))}
                className="w-full h-2 bg-[#2A2A2A] rounded-full appearance-none cursor-pointer"
                style={{
                  background: `linear-gradient(to right, #F59E0B ${((driverCount - 1) / 19) * 100}%, #2A2A2A ${((driverCount - 1) / 19) * 100}%)`,
                }}
              />
              <div className="flex justify-between text-xs text-[#6B7280] mt-2 font-mono">
                <span>1 driver</span>
                <span>20 drivers</span>
              </div>
            </div>

            {/* Earnings grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-[#111111] border border-[#F59E0B]/30 rounded-xl p-5 text-center amber-glow">
                <p className="text-xs text-[#F59E0B] font-mono uppercase tracking-wider mb-2">Monthly Payout</p>
                <p className="font-mono text-3xl font-bold text-white">
                  EC${monthlyEarnings?.toFixed(0)}
                </p>
                <p className="text-xs text-[#6B7280] mt-1">paid once per month</p>
              </div>
              <div className="bg-[#111111] border border-[#2A2A2A] rounded-xl p-5 text-center">
                <p className="text-xs text-[#6B7280] font-mono uppercase tracking-wider mb-2">Annual</p>
                <p className="font-mono text-2xl font-bold text-[#10B981]">
                  EC${annualEarnings?.toFixed(0)}
                </p>
                <p className="text-xs text-[#6B7280] mt-1">projected</p>
              </div>
            </div>

            <p className="text-xs text-[#6B7280] text-center mt-6 border-t border-[#2A2A2A] pt-6">
              ⚠️ Estimates only. Based on average 18 deliveries/driver/month at EC$4.50 commission per delivery. Actual earnings depend on driver activity levels.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}